/**
 * The colour used in the background of the logo.
 */
export const LOGO_COLOR = {
  hue: 30,
  saturation: 96,
  lightness: 55,
};

/**
 * The colours used to accent the UI.
 */
export const ACCENT_COLOR = {
  main: {
    hue: 30,
    saturation: 25,
    lightness: 71,
  },
  darker: {
    hue: 30,
    saturation: 93,
    lightness: 33,
  },
  contrastText: {
    hue: 30,
    saturation: 10,
    lightness: 18,
  },
  background: {
    hue: 30,
    saturation: 52,
    lightness: 55,
  },
  backgroundContrastText: {
    hue: 30,
    saturation: 11,
    lightness: 24,
  },
};
